import { Box, Typography } from '@mui/material';

export const EmailSent = ({ name, email }: { name: string; email: string }) => {
  return (
    <Box mt="42px">
      <Typography
        component="h1"
        fontWeight={700}
        fontSize={28}
        color="#091E42"
        lineHeight="32.81px"
      >
        Welcome to Pod
      </Typography>
      <Typography
        mt="12px"
        fontWeight={400}
        fontSize={14}
        color="rgba(0, 0, 0, 0.67)"
        lineHeight="21px"
      >
        Hi{' '}
        <Typography component="span" sx={{ textTransform: 'capitalize' }}>
          {name}
        </Typography>
        , an email has been sent to{' '}
        <Typography component="span">{email}</Typography>. Please confirm it to
        proceed further.
      </Typography>
      <Typography
        mt="200px"
        fontWeight={400}
        fontSize={12}
        color="rgba(0, 0, 0, 0.67)"
        lineHeight="21px"
      >
        Note: If you don&apos;t receive the confirmation email within a few
        minutes of signing up, please check your Spam or Bulk E-Mail folder.
      </Typography>
    </Box>
  );
};
